import { copy, option, state, stepKeys } from './model';

export function renderHeader(): string {
  const c = copy();
  return `
    <header class="site-header">
      <a class="wordmark" href="#top" aria-label="MKProjectLab home">${c.brand}</a>
      <div class="header-controls">
        <label class="compact-select">
          <span>${c.languageLabel}</span>
          <select data-action="locale" aria-label="${c.languageLabel}">
            ${option('en-GB', 'EN', state.locale === 'en-GB')}
            ${option('pl-PL', 'PL', state.locale === 'pl-PL')}
          </select>
        </label>
        <span class="demo-badge">${c.concept}</span>
      </div>
    </header>`;
}

export function renderHero(): string {
  const c = copy();
  return `
    <section class="hero" id="top">
      <div class="hero-copy">
        <p class="eyebrow">${c.conceptLabel}</p>
        <h1>${c.title}</h1>
        <p class="hero-lead">${c.subtitle}</p>
        <p class="hero-note">${c.intro}</p>
      </div>
      <div class="hero-visual" aria-hidden="true">
        <div class="visual-window">
          <div class="visual-toolbar"><span></span><span></span><span></span></div>
          <div class="visual-body">
            <div class="visual-progress"><i></i><i></i><i></i><i></i><i></i></div>
            <div class="visual-grid">
              <div class="visual-form"><b></b><b></b><b></b><b></b></div>
              <div class="visual-quote"><small>ESTIMATE</small><strong>${state.market === 'UK' ? '£1,080–£1,380' : '4 350–5 550 zł'}</strong><span></span><span></span></div>
            </div>
          </div>
        </div>
      </div>
    </section>`;
}

export function renderProgress(): string {
  const c = copy();
  return `
    <nav class="progress" aria-label="Calculator progress">
      ${stepKeys.map((key, index) => `
        <button type="button" data-action="go-step" data-step="${index}" class="progress-step ${index === state.step ? 'is-current' : ''} ${index < state.step ? 'is-complete' : ''}" ${index > state.step ? 'disabled' : ''}>
          <span>${index + 1}</span><small>${c[key]}</small>
        </button>`).join('')}
    </nav>`;
}
